import occupations from './occupations';
import buildingtypes from './buildingtypes';
var path = '/common';
var common = function (url) { return function () { return ({
    occupations: occupations(url + path),
    buildingtypes: buildingtypes(url + path),
}); }; };
export default common;
